import { render, staticRenderFns } from "./cardInfo.vue?vue&type=template&id=2fe66d64&scoped=true"
import script from "./cardInfo.vue?vue&type=script&lang=js"
export * from "./cardInfo.vue?vue&type=script&lang=js"
import style0 from "./cardInfo.vue?vue&type=style&index=0&id=2fe66d64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe66d64",
  null
  
)

export default component.exports